var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width-100 display-flex flex-row flex-align-center tabs-container px-5 py-2"},[(_vm.installationMode)?_c('InstallationWizardTabs',_vm._g(_vm._b({},'InstallationWizardTabs',_vm.$attrs,false),_vm.$listeners)):_c('EditConfigurationTabs',_vm._g(_vm._b({},'EditConfigurationTabs',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }